export default "__VITE_ASSET__2kXDOwcc__"